import { Box, Typography } from 'bonfire-kindling';

const StackedListItem = ({ sx, ...props }) => (
  <Box
    component="li"
    sx={{
      '&:not(:last-of-type)': {
        borderBottom: theme => `1px solid ${theme.palette.grey.lightest}`,
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      padding: '0.625rem 0',
      ...sx,
    }}
    {...props}
  />
);

const StackedList = ({ title, children }) => (
  <Box
    sx={{
      backgroundColor: theme => theme.palette.common.white,
      border: theme => `1px solid ${theme.palette.grey.lighter}`,
      borderRadius: '3px',
      width: '100%',
    }}
  >
    {title && (
      <Box
        sx={{
          borderBottom: theme => `1px solid ${theme.palette.grey.lightest}`,
          padding: '1.25rem',
        }}
      >
        <Typography variant="h4" component="h3">
          {title}
        </Typography>
      </Box>
    )}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '0 1.25rem',
        listStyleType: 'none',
      }}
      component="ul"
    >
      {children}
    </Box>
  </Box>
);

StackedList.Item = StackedListItem;

export default StackedList;
